export default {
  // Page Meta
  meta: {
    title: 'Contact Us | NutriBot',
    description: 'Get in touch with NutriBot support. We\'re here to help with any questions about your nutrition plan, technical issues, or account management.',
  },

  // Hero Section
  hero: {
    title: 'Contact Us',
    subtitle: 'We\'re here to help. Get in touch with our team.',
  },

  // Contact Methods
  methods: {
    email: {
      title: 'Email Us',
      content: 'support@nutribot.com',
      subtitle: 'We\'ll respond within 24 hours',
    },
    chat: {
      title: 'Live Chat',
      content: 'Chat with our AI assistant',
      subtitle: 'Available 24/7 for instant help',
      button: 'Start Chat',
    },
    faq: {
      title: 'Help Center',
      content: 'Browse our FAQ',
      subtitle: 'Find answers to common questions',
      link: 'View FAQ',
    },
  },

  // Contact Form
  form: {
    title: 'Send us a Message',
    subtitle: 'Fill out the form below and we\'ll get back to you soon.',
    fields: {
      firstName: 'First Name',
      firstNamePlaceholder: 'John',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Doe',
      email: 'Email Address',
      emailPlaceholder: 'john@example.com',
      subject: 'Subject',
      subjectPlaceholder: 'Select a subject',
      message: 'Message',
      messagePlaceholder: 'Tell us how we can help you...',
    },
    subjects: {
      general: 'General Inquiry',
      technical: 'Technical Support',
      billing: 'Billing Question',
      partnership: 'Partnership Opportunity',
      feedback: 'Feedback',
      other: 'Other',
    },
    submit: 'Send Message',
    submitting: 'Sending...',
    
    // Validation
    validation: {
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      emailRequired: 'Email is required',
      emailInvalid: 'Please enter a valid email address',
      subjectRequired: 'Please select a subject',
      messageRequired: 'Message is required',
      messageMin: 'Message must be at least 10 characters',
    },

    // Success/Error
    success: {
      title: 'Message Sent!',
      message: 'Thank you for contacting us. We\'ll get back to you within 24 hours.',
      button: 'Send Another Message',
    },
    error: {
      title: 'Failed to Send',
      message: 'Something went wrong. Please try again or email us directly.',
      button: 'Try Again',
    },
  },

  // Additional Info
  info: {
    hours: {
      title: 'Support Hours',
      weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM CET',
      saturday: 'Saturday: 10:00 AM - 4:00 PM CET',
      sunday: 'Sunday: Closed',
      note: 'AI assistant available 24/7',
    },
    location: {
      title: 'Based in Switzerland',
      city: 'Zurich, Switzerland',
      serving: 'Serving customers worldwide',
      note: 'Remote-first team',
    },
  },

  // FAQ Section
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Quick answers to common questions',
    questions: [
      {
        question: 'How do I upgrade to VIP?',
        answer: 'You can upgrade to VIP anytime from your profile settings. Click on your plan badge and select "Upgrade to VIP". You\'ll get instant access to all premium features including the AI nutrition coach, personalized meal plans, and detailed recipes.',
      },
      {
        question: 'Can I cancel my subscription anytime?',
        answer: 'Yes! You can cancel your subscription at any time from your profile settings. Your VIP access will remain active until the end of your current billing period. No cancellation fees or commitments required.',
      },
      {
        question: 'How does the AI nutrition coach work?',
        answer: 'Our AI coach (NutriBot) uses advanced language models to provide personalized nutrition guidance. It learns from your goals, preferences, and progress to create custom meal plans, answer questions, and adjust your plan based on your feedback.',
      },
      {
        question: 'Do you offer refunds?',
        answer: 'We offer a 30-day money-back guarantee for VIP subscriptions. If you\'re not satisfied within the first 30 days, contact support for a full refund. After 30 days, refunds are handled on a case-by-case basis.',
      },
      {
        question: 'Is my data secure?',
        answer: 'Absolutely. We use bank-level encryption to protect your data. All information is stored securely on Supabase servers with end-to-end encryption. We never share your personal information with third parties without your explicit consent.',
      },
      {
        question: 'Can I customize my meal plans?',
        answer: 'Yes! VIP members can fully customize their meal plans. You can swap meals, adjust calories, change dietary preferences, and exclude specific ingredients. The AI coach will regenerate your plan based on your preferences.',
      },
      {
        question: 'Do you support dietary restrictions?',
        answer: 'Yes, we support all major dietary restrictions including vegetarian, vegan, gluten-free, dairy-free, nut allergies, and more. You can specify your restrictions during onboarding or update them anytime in your profile settings.',
      },
      {
        question: 'How do I contact support?',
        answer: 'You can reach us via email at support@nutribot.com, or use the contact form on this page. For urgent issues, email is the fastest way to reach our human support team.',
      },
    ],
  },

  // Toast Messages
  toast: {
    messageSent: 'Message sent successfully!',
    messageFailed: 'Failed to send message',
    emailCopied: 'Email address copied to clipboard',
    rateLimitExceeded: 'Too many requests. Please try again later.',
  },
};
